import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVettingConfig } from '../services/vettingApplications';
import { vettingConfigQueryKeys } from './query-keys';

export const useUpdateVettingConfigMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation({
    mutationFn: async (payload) => {
      const result = await updateVettingConfig(payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to update vetting config');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: vettingConfigQueryKeys.all });
      await onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};
